module.exports = __webpack_public_path__ + "img/PhantomAssassin.16d72e38.png";